import { Component, Input, OnInit, Output,EventEmitter,SimpleChanges, ViewChild, OnChanges, ViewEncapsulation } from '@angular/core';
import { Acm } from 'app/models/loyalty-acm.model';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';
import { Campaign3KontableComponent } from '../../campaign-3-kontable/campaign-3-kontable.component';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { Campaign3Service } from 'app/views/campaign-3/services/campaign3.service';

@Component({
  selector: 'app-campaign-3-search-accumulators',
  templateUrl: './campaign-3-search-accumulators.component.html',
  styleUrls: ['./campaign-3-search-accumulators.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Campaign3SearchAccumulatorsComponent implements OnInit {

@Input() dateStart: string = "";
@Input() dateEnd: string = "";
@Output() acmSelected: EventEmitter<Array<Acm>> = new EventEmitter<Array<Acm>>();
@Input() accumulatorList: Array<any>;
@Input() multipleselection :boolean =false;


  public dateFilter = Campaign3KontableComponent.DateFilter;
  listAcm: Array<any> = [];
  paginationType: number = Campaign3KontableComponent.NoPagination;
  show = {
    table: false
  }
  listAcmSelected: Array<any> = [];
  constructor(
    private srvLoyaltyAcm: LoyaltyAcmService,
    public srvCalTranslate: CalendarTranslateService,
    private srvCampaign3: Campaign3Service
    ) {

  }
ngOnInit() {
  if(this.accumulatorList){
    // Seleziono gli accumulatori marcati
    for(let acm of this.accumulatorList){
      if(acm.rowSelected == true){
        this.listAcmSelected.push(Object.assign({}, acm));
      }
    }

      this.listAcm = Object.assign([],this.accumulatorList);
      this.filterAccumulatorsByCampaignDate();
      this.show.table = true;
    }

  }
 filterAccumulatorsByCampaignDate(){
  const filtered: Array<any> = [];

  for (let acm of this.accumulatorList) {
    let error = false;
    let ds = null;

    if (acm.dateStart) {
      ds = this.srvCampaign3.getDateFromDateStringDB(acm.dateStart);
    }

    if (ds && ds < this.srvCampaign3.getDateFromDateStringDB(this.dateStart)) {
      error = true;
    }

    if (!error) {
      filtered.push(acm);
    }
  }

  this.listAcm = filtered;
}

  onClickAggiungi_ModalAccumulatori(){
    this.acmSelected.emit(this.listAcmSelected);
  }
  onClickAnnulla_ModalAccumulatori(){
    this.acmSelected.emit(null);
  }
 onAcmSelected(acm: any) {
  if (this.multipleselection) {
    // --- Comportamento multipla selezione (originale onAcmSelected)
    let indexInSelected = this.listAcmSelected.findIndex(x => x.id == acm.id);

    if (!acm.rowSelected) {
      if (indexInSelected > -1) {
        this.listAcmSelected.splice(indexInSelected, 1);
      }
    } else {
      if (indexInSelected == -1) {
        this.listAcmSelected.push(acm);
      }
    }

  } else {
    // --- Comportamento selezione singola (originale onAcmSelected2)
    this.accumulatorList.forEach(item => {
      if (item.id !== acm.id) {
        item.rowSelected = false;
      }
    });

    if (acm.rowSelected) {
      this.listAcmSelected = [acm];
    } else {
      this.listAcmSelected = [];
    }
  }
}


}



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/modals/search-accumulators/campaign-3-search-accumulators.component.ts